import { z } from "zod";
import * as TwoDigitYear from "./two-digit-year.js";
import * as ShortMonth from "./short-month.js";
import * as R from "remeda";
export const shortMonthToMonthCode = {
    JAN: "F",
    FEB: "G",
    MAR: "H",
    APR: "J",
    MAY: "K",
    JUN: "M",
    JUL: "N",
    AUG: "Q",
    SEP: "U",
    OCT: "V",
    NOV: "X",
    DEC: "Z",
};
export const monthCodeToShortMonth = R.invert(shortMonthToMonthCode);
export const orderedMonthCodes = [
    "F",
    "G",
    "H",
    "J",
    "K",
    "M",
    "N",
    "Q",
    "U",
    "V",
    "X",
    "Z",
];
export const monthCodeFromMonthCodeYY = (monthCodeYY) => monthCodeYY.charAt(0);
export const monthCodeFromMonthIndex = (monthIndex) => orderedMonthCodes[monthIndex];
export const monthIndexFromMonthCode = (monthCode) => orderedMonthCodes.indexOf(monthCode);
export const monthIndexFromNumber = (num) => ((((num | 0) % 12) + 12) % 12);
export const monthIndexAdd = (num, monthIndex) => monthIndexFromNumber(monthIndex + num);
export const monthCodeFromNumber = (num) => monthCodeFromMonthIndex(monthIndexFromNumber(num));
export const monthIndexFromMonthCodeYY = (monthCodeYY) => monthIndexFromMonthCode(monthCodeFromMonthCodeYY(monthCodeYY));
export const monthIndexFromDayjs = (date) => date.month();
export const monthIndexFromDate = (date) => date.getMonth();
export const monthIndexFromUTCDate = (date) => date.getUTCMonth();
export const monthIndexFromISODateString = (date) => (ShortMonth.monthNumberFromISODateString(date) - 1);
export const monthCodeFromISODateString = (date) => monthCodeFromMonthIndex(monthIndexFromISODateString(date));
export const monthCodeFromDayjs = (date) => monthCodeFromMonthIndex(date.month());
export const monthCodeFromDate = (date) => monthCodeFromMonthIndex(date.getMonth());
export const monthCodeFromUTCDate = (date) => monthCodeFromMonthIndex(date.getUTCMonth());
const monthCodeYYRegex = /^[FGHJKMNQUVXZ]\d{2}$/;
export const schema = z.stringFormat("MonthCodeYY", (val) => monthCodeYYRegex.test(val)).brand();
// use regex directly, as it's LOADs faster than going through zod's schema
export const is = (str) => monthCodeYYRegex.test(str);
export const as = (val) => val;
export const fromMonthCodeAndYear = (monthCode, year) => as(`${monthCode}${year}`);
export const fromShortMonthYY = (val) => fromMonthCodeAndYear(shortMonthToMonthCode[ShortMonth.fromShortMonthYY(val)], TwoDigitYear.fromShortMonthYY(val));
export const fromCiShortMonthYY = (val) => fromMonthCodeAndYear(shortMonthToMonthCode[ShortMonth.fromCiShortMonthYY(val)], TwoDigitYear.fromShortMonthYY(val));
/**
 * Converts a month code string in the format YYYY-MM-DD to a month code with two digit year
 */
export const fromISODateString = (calendarDate) => fromMonthCodeAndYear(monthCodeFromISODateString(calendarDate), TwoDigitYear.fromISODateString(calendarDate));
export const fromDayjs = (date) => fromMonthCodeAndYear(monthCodeFromDayjs(date), TwoDigitYear.fromDayjs(date));
export const fromDate = (date) => fromMonthCodeAndYear(monthCodeFromDate(date), TwoDigitYear.fromDate(date));
export const fromUTCDate = (date) => fromMonthCodeAndYear(monthCodeFromUTCDate(date), TwoDigitYear.fromUTCDate(date));
//# sourceMappingURL=month-code.js.map